import { useState, useEffect } from 'react'
import { Bar } from 'react-chartjs-2'
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router';
const BarChart = () => {
    const [teamsTop, setTeamsTop] = useState([]);
    const [scoresTop, setScoresTop] = useState([]);
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const history = useHistory();
    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/scoreboard/getTop10`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                setTeamsTop(response.data[0])
                setScoresTop(response.data[1])
            }
        })
    }, []);
   
    return (
        <div>
            <Bar
                data={{
                    labels: teamsTop,
                    datasets: [
                        {
                            label: 'Puntaje',
                            data: scoresTop,
                            backgroundColor: ['rgba(255,99,132,0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(220, 159, 64, 0.2)',
                            'rgba(245, 40, 145, 0.2)',
                            'rgba(23, 106, 113, 0.2)',
                            'rgba(23, 71, 113, 0.2)',
                            'rgba(107, 162, 1, 0.2)',
                        ],
                            borderColor: ['rgba(255,99,132,1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                            'rgba(245, 40, 145, 1)',
                            'rgba(23, 106, 113, 1)',
                            'rgba(23, 71, 113, 1)',
                            'rgba(107, 162, 1, 1)',
                        ],

                            borderWidth: 1,
                            hoverBackgroundColor: 'rgba(37, 50, 68,0.2)',
                            hoverBorderColor: ['rgba(255,99,132,1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                        ],
                        },
                        

                    ]
                }}
                height={400}
                width={600}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        labels: {
                            fontColor: "blue",
                            fontSize: 18
                        }
                    },
                   

                }}
            />
        </div>

    )
}

export default BarChart
